<div id="login-wrapper" class="container-fluid h-100">
  <div id="login-content" class="row align-items-center justify-content-center">
    <div class="col-lg-auto">
      <div id="brand">
        <img id="seos-logo" [src]="'assets/images/seos_logo.png'">
        <img id="seos-text" [src]="'assets/images/seos_text.png'">
        <div id="seos-long-text">smart education operating system</div>
      </div>
    </div>
    <div class="col-lg-auto d-none d-lg-block">
      <div id="divider"></div>
    </div>
    <div class="col-lg-4 col-xl-3">
      <div id="login-form-wrapper" class="col p-4">
        <div class="title">{{ 'LOGIN.BOARD_REGISTRATION' | translate }}</div>
        <form #loginForm="ngForm" class="p-2" (ngSubmit)="onSubmit()" method="post" novalidate>
          <div id="licenceCode-group" class="form-floating mb-3 row">
              <input id="licenceCode" type="text" name="licenceCode" class="form-control form-control-lg require-border-none"
                     #licenceCode="ngModel"
                     [placeholder]="'LOGIN.PASSWORD' | translate"
                     [(ngModel)]="boardRequest.licenceCode"
                     [ngClass]="{ 'is-invalid': !licenceCode.valid && !licenceCode.pristine }" autofocus required>
            <label for="licenceCode">{{ 'LOGIN.LICENCE_CODE' | translate }}</label>
          </div>
          <div class="row">
            <button type="submit" class="btn btn-lg btn-primary w-100" [disabled]="loginForm.invalid">
              {{ 'LOGIN.REGISTRATION' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
